import React from "react";

const ClockIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <mask id="mask0_2799_8429" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
      <rect width="14" height="14" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2799_8429)">
      <path d="M8.92533 9.74175L9.74199 8.92508L7.58366 6.76675V4.08342H6.41699V7.23342L8.92533 9.74175ZM7.00033 12.8334C6.19338 12.8334 5.43505 12.6803 4.72533 12.374C4.0156 12.0678 3.39824 11.6522 2.87324 11.1272C2.34824 10.6022 1.93262 9.9848 1.62637 9.27508C1.32012 8.56536 1.16699 7.80703 1.16699 7.00008C1.16699 6.19314 1.32012 5.4348 1.62637 4.72508C1.93262 4.01536 2.34824 3.398 2.87324 2.873C3.39824 2.348 4.0156 1.93237 4.72533 1.62612C5.43505 1.31987 6.19338 1.16675 7.00033 1.16675C7.80727 1.16675 8.5656 1.31987 9.27533 1.62612C9.98505 1.93237 10.6024 2.348 11.1274 2.873C11.6524 3.398 12.068 4.01536 12.3743 4.72508C12.6805 5.4348 12.8337 6.19314 12.8337 7.00008C12.8337 7.80703 12.6805 8.56536 12.3743 9.27508C12.068 9.9848 11.6524 10.6022 11.1274 11.1272C10.6024 11.6522 9.98505 12.0678 9.27533 12.374C8.5656 12.6803 7.80727 12.8334 7.00033 12.8334ZM7.00033 11.6667C8.29338 11.6667 9.39442 11.2122 10.3035 10.3032C11.2125 9.39418 11.667 8.29314 11.667 7.00008C11.667 5.70703 11.2125 4.60598 10.3035 3.69696C9.39442 2.78793 8.29338 2.33341 7.00033 2.33341C5.70727 2.33341 4.60623 2.78793 3.6972 3.69696C2.78817 4.60598 2.33366 5.70703 2.33366 7.00008C2.33366 8.29314 2.78817 9.39418 3.6972 10.3032C4.60623 11.2122 5.70727 11.6667 7.00033 11.6667Z" fill="#999999"/>
    </g>
  </svg>
);

export default ClockIcon;
